import { combineReducers } from "redux";
import header from "./header";
import siteConfig from "./site-config";
import showBack from "./show-back";
import home from "./home";
import form from './form-reducer'
export default combineReducers({
    header,
    home,
    showBack,
    siteConfig,
    form
});


// WEBPACK FOOTER //
// ./src/reducers/index.js